import BaseList, { ListProps as BaseProps } from 'antd/lib/list'
import { Item } from './item'

export type { ListItemProps, ListItemMetaProps } from './item'

export interface ListProps<T> extends BaseProps<T> {}

function List<T>(props: ListProps<T>): JSX.Element {
  return (
    <>
      <BaseList {...props} />
    </>
  )
}

List.Item = Item

export { List }
